import AdvancedImg1 from '/static/img/newProductDetils/all-aba/server/Advanced/img1.png'
import AdvancedImg2 from '/static/img/newProductDetils/all-aba/server/Advanced/img2.png'
import AdvancedImg3 from '/static/img/newProductDetils/all-aba/server/Advanced/img3.jpg'
import AdvancedImg4 from '/static/img/newProductDetils/all-aba/server/Advanced/img4.jpg'
import DeluxeImg1 from '/static/img/newProductDetils/all-aba/server/Deluxe/img1.png'
import DeluxeImg2 from '/static/img/newProductDetils/all-aba/server/Deluxe/img2.png'
import DeluxeImg3 from '/static/img/newProductDetils/all-aba/server/Deluxe/img3.jpg'
import DeluxeImg4 from '/static/img/newProductDetils/all-aba/server/Deluxe/img4.jpg'
import LuxuryImg1 from '/static/img/newProductDetils/all-aba/server/Luxury/img1.png'
import LuxuryImg2 from '/static/img/newProductDetils/all-aba/server/Luxury/img2.png'
import LuxuryImg3 from '/static/img/newProductDetils/all-aba/server/Luxury/img3.jpg'
import LuxuryImg4 from '/static/img/newProductDetils/all-aba/server/Luxury/img4.jpg'
let serverList1 = [//高端
    {
        id:1,
        title:'Accommodations',
        descList:['All Seasons Hotel, MUSTEL, or comparable 4-star standard hotels.']
    },
    {
        id:2,
        title:'Transportation',
        descList:['Volkswagen Passat, BYD Han, or equivalent premium sedans' ]
    },
    {
        id:3,
        title:'Services',
        descList:['Professional itinerary butler','Airport pickup service','Full-time driver',' 24-hour emergency medical VIP access']
    },
]
let serverList2= [//中端
    {
        id:1,
        title:'Accommodations',
        descList:['Marriott,Hilton,or comparable 5-star standard hotels.' ]
    },
    {
        id:2,
        title:'Transportation',
        descList:['BMW 7 Series, Mercedes-Benz S-Class, or equivalent luxury sedans']
    },
    {
        id:3,
        title:'Services',
        descList:['Professional itinerary butler','Airport pickup service','Full-time driver','24-hour emergency medical VIP access','Local specialty snack gift pack']
    },
]
let serverList3= [//普通
    {
        id:1,
        title:'Accommodations',
        descList:['Waldorf Astoria Hotel,Niccolo Hotel,or comparable luxury hotels.']
    },
    {
        id:2,
        title:'Transportation',
        descList:['Rolls-Royce or equivalent ultra-luxury vehicles.']
    },
    {
        id:3,
        title:'Services',
        descList:['Professional itinerary butler','Charter flight service','Helicopter service','Private banquet by renowned chefs','Bodyguard service','Photography service','Escort service']
    },
]
let levelTabList = [//服务级别
    {
        id:1,
        title:'Advanced',
    },
    {
        id:2,
        title:'Deluxe',
    },
    {
        id:3,
        title:'Luxury',
    }
]
const  configurationLevelInfo = [
    {
        id:1,
        timeTabList:[
            {
                id:1,
                title:'Three-Day Trip A',
            },
            {
                id:2,
                title:'Three-Day Trip B',
            },
            {
                id:3,
                title:'Three-Day Trip C',
            },
            
        ],
        list:[
            {
                id:1,
                title:'Three-Day Trip A',
                positionList:[//有哪些地方
                    {
                            id:1,
                            name: 'Jiuzhaigou County',
                            content:['Jiuzhaigou','Songzhou Ancient City','Huanglong']
                    },
                ],
                levelListInfo:{//有哪些服务
                    levelTabList:levelTabList,
                    allServerListList:[
                        {
                            id:1,
                            serverList:serverList1,
                            // 轮播图
                             swiperList:[
                                {id:1,img:AdvancedImg1},
                                {id:2,img:AdvancedImg2},
                                {id:3,img:AdvancedImg3},
                                {id:4,img:AdvancedImg4}
                             ]
                        },
                        {
                            id:2,
                            serverList:serverList2,
                            swiperList:[
                                {id:1,img:DeluxeImg1},
                                {id:2,img:DeluxeImg2},
                                {id:3,img:DeluxeImg3},
                                {id:4,img:DeluxeImg4}
                            ]
                        },
                        {
                            id:3,
                            serverList:serverList3,
                            swiperList:[
                                {id:1,img:LuxuryImg1},
                                {id:2,img:LuxuryImg2},
                                {id:3,img:LuxuryImg3},
                                {id:4,img:LuxuryImg4}
                            ]
                        },
                    ],
                }
        
            },
            {
                id:2,
                title:'Three-Day Trip B',
                positionList:[//有哪些地方
                    {
                            id:1,
                            name: 'Xiaojin County',
                            content:['Balang Mountain','Shuangqiao Valley of Siguniang Mountain','Lixia Road ']
                    },
                    {
                        id:2,
                        name: 'Lixian County',
                        content:['Balang Mountain']
                    },
                ],
                levelListInfo:{//有哪些服务
                    levelTabList:levelTabList,
                    allServerListList:[
                        {
                            id:1,
                            serverList:serverList1,
                            // 轮播图
                             swiperList:[
                                {id:1,img:AdvancedImg1},
                                {id:2,img:AdvancedImg2},
                                {id:3,img:AdvancedImg3},
                                {id:4,img:AdvancedImg4}
                             ]
                        },
                        {
                            id:2,
                                serverList:serverList2,
                            swiperList:[
                                {id:1,img:DeluxeImg1},
                                {id:2,img:DeluxeImg2},
                                {id:3,img:DeluxeImg3},
                                {id:4,img:DeluxeImg4}
                            ]
                        },
                        {
                            id:3,
                            serverList:serverList3,
                            swiperList:[
                                {id:1,img:LuxuryImg1},
                                {id:2,img:LuxuryImg2},
                                {id:3,img:LuxuryImg3},
                                {id:4,img:LuxuryImg4}
                            ]
                        },
                    ],
                }
        
            },
            {
                id:3,
                title:'Three-Day Trip C',
                positionList:[//有哪些地方
                    {
                            id:1,
                            name: 'Lixian County',
                            content:['Bipenggou']
                    },
                    {
                        id:2,
                        name: 'Heishui County',
                        content:['Dagu Glacier','Fairy Tale Highway']
                    },
                ],
                levelListInfo:{//有哪些服务
                    levelTabList:levelTabList,
                    allServerListList:[
                        {
                            id:1,
                            serverList:serverList1,
                            // 轮播图
                             swiperList:[
                                {id:1,img:AdvancedImg1},
                                {id:2,img:AdvancedImg2},
                                {id:3,img:AdvancedImg3},
                                {id:4,img:AdvancedImg4}
                            ]
                        },
                        {
                            id:2,
                            serverList:serverList2,
                            swiperList:[
                                {id:1,img:DeluxeImg1},
                                {id:2,img:DeluxeImg2},
                                {id:3,img:DeluxeImg3},
                                {id:4,img:DeluxeImg4}
                            ]
                        },
                        {
                            id:3,
                            serverList:serverList3,
                            swiperList:[
                                {id:1,img:LuxuryImg1},
                                {id:2,img:LuxuryImg2},
                                {id:3,img:LuxuryImg3},
                                {id:4,img:LuxuryImg4}
                            ]
                        },
                    ],
                }
            },
        ]
    },
    {
        id:2,
        timeTabList:[
            {
                id:1,
                title:'5-Day Daocheng Yading Tour',
            },
            {
                id:2,
                title:'5-Day Genie South Line Tour',
            },
            {
                id:3,
                title:"7-Day Genie South Line + Daocheng Yading Tour"
            },
            {
                id:4,
                title:"7-day tour of Gnie'nan Line + Seda + Mount Siguniang"
            }
            
        ],
        list:[
            {
                id:1,
                title:'5-Day Daocheng Yading Tour',
                positionList:[//有哪些地方
                    {
                        id:1,
                        name: 'Kangding',
                        content:['Yuzixi','Tagong Grassland','Honghaizi','Zheduo Mountain']
                    },
                    {
                        id:2,
                        name: 'Yajiang',
                        content:['Eighteen Bends of the Heavenly Road']
                    },
                    {
                        id:3,
                        name: 'Litang',
                        content:['Letong Ancient Town','Changqingchun Ke\'er Monastery']
                    },
                    {
                        id:4,
                        name: 'Daocheng',
                        content:['Daocheng Yading']
                    },
                ],
                levelListInfo:{//有哪些服务
                    levelTabList:levelTabList,
                    allServerListList:[
                        {
                            id:1,
                            serverList:serverList1,
                            // 轮播图
                             swiperList:[
                                {id:1,img:AdvancedImg1},
                                {id:2,img:AdvancedImg2},
                                {id:3,img:AdvancedImg3},
                                {id:4,img:AdvancedImg4}
                             ]
                        },
                        {
                            id:2,
                            serverList:serverList2,
                            swiperList:[
                                {id:1,img:DeluxeImg1},
                                {id:2,img:DeluxeImg2},
                                {id:3,img:DeluxeImg3},
                                {id:4,img:DeluxeImg4}
                            ]
                        },
                        {
                            id:3,
                            serverList:serverList3,
                            swiperList:[
                                {id:1,img:LuxuryImg1},
                                {id:2,img:LuxuryImg2},
                                {id:3,img:LuxuryImg3},
                                {id:4,img:LuxuryImg4}
                            ]
                        },
                    ],
                }
        
            },
            {
                id:2,
                title:'5-Day Genie South Line Tour',
                positionList:[//有哪些地方
                    {
                            id:1,
                            name: 'Kangding',
                            content:['Yuzixi','Tagong Grassland','Honghaizi','Zheduo Mountain']
                    },
                    {
                        id:2,
                        name: 'Yajiang',
                        content:['Eighteen Bends of the Heavenly Road']
                    },
                    {
                        id:3,
                        name: 'Litang',
                        content:['Letong Ancient Town','Changqingchun Ke\'er Monastery','The Eye of Genie']
                    },
                    {
                        id:4,
                        name: 'Batang',
                        content:['Cuopu Valley','Sisters Lakes']
                    },
                ],
                levelListInfo:{//有哪些服务
                    levelTabList:levelTabList,
                    allServerListList:[
                        {
                            id:1,
                            serverList:serverList1,
                            // 轮播图
                             swiperList:[
                                {id:1,img:AdvancedImg1},
                                {id:2,img:AdvancedImg2},
                                {id:3,img:AdvancedImg3},
                                {id:4,img:AdvancedImg4}
                             ]
                        },
                        {
                            id:2,
                                serverList:serverList2,
                            swiperList:[
                                {id:1,img:DeluxeImg1},
                                {id:2,img:DeluxeImg2},
                                {id:3,img:DeluxeImg3},
                                {id:4,img:DeluxeImg4}
                            ]
                        },
                        {
                            id:3,
                            serverList:serverList3,
                            swiperList:[
                                {id:1,img:LuxuryImg1},
                                {id:2,img:LuxuryImg2},
                                {id:3,img:LuxuryImg3},
                                {id:4,img:LuxuryImg4}
                            ]
                        },
                    ],
                }
        
            },
            {
                id:3,
                title:'7-Day Genie South Line + Daocheng Yading Tour',
                positionList:[//有哪些地方
                    {
                        id:1,
                        name: 'Kangding',
                        content:['Yuzixi  Tagong Grassland','Honghaizi','Zheduo Mountain']
                    },
                    {
                        id:2,
                        name: 'Yajiang',
                        content:['Eighteen Bends of the Heavenly Road']
                    },
                    {
                        id:3,
                        name: 'Litang',
                        content:['Letong Ancient Town','Changqingchun Ke\'er MonasteryDaocheng Daocheng Yading']
                    },
                    {
                        id:4,
                        name: 'Batang',
                        content:['Cuopu Valley','Sisters Lakes']
                    },
                    {
                        id:5,
                        name: 'Daocheng',
                        content:['Daocheng Yading']
                    },
                ],
                levelListInfo:{//有哪些服务
                    levelTabList:levelTabList,
                    allServerListList:[
                        {
                            id:1,
                            serverList:serverList1,
                            // 轮播图
                             swiperList:[
                                {id:1,img:AdvancedImg1},
                                {id:2,img:AdvancedImg2},
                                {id:3,img:AdvancedImg3},
                                {id:4,img:AdvancedImg4}
                            ]
                        },
                        {
                            id:2,
                            serverList:serverList2,
                            swiperList:[
                                {id:1,img:DeluxeImg1},
                                {id:2,img:DeluxeImg2},
                                {id:3,img:DeluxeImg3},
                                {id:4,img:DeluxeImg4}
                            ]
                        },
                        {
                            id:3,
                            serverList:serverList3,
                            swiperList:[
                                {id:1,img:LuxuryImg1},
                                {id:2,img:LuxuryImg2},
                                {id:3,img:LuxuryImg3},
                                {id:4,img:LuxuryImg4}
                            ]
                        },
                    ],
                }
            },
            {
                id:4,
                title:'7-day tour of Gnie\'nan Line + Seda + Mount Siguniang',
                positionList:[//有哪些地方
                    {
                        id:1,
                        name: 'Kangding',
                        content:['Yuzixi','Tagong Grassland','Honghaizi','Zheduo Mountain','Moshi Park']
                    },
                    {
                        id:2,
                        name: 'Yajiang',
                        content:['Eighteen Bends of the Heavenly Road']
                    },
                    {
                        id:3,
                        name: 'Litang',
                        content:['Letong Ancient Town','Changqingchun Ke\'er MonasteryDaocheng Daocheng Yading']
                    },
                    {
                        id:4,
                        name: 'Batang',
                        content:['Cuopu Valley','Sisters Lakes']
                    },
                    {
                        id:5,
                        name: 'Seda',
                        content:['Wuming Buddhist Academy']
                    },
                    {
                        id:6,
                        name: 'Danba',
                        content:['Yala Snow Mountain Viewing Platform']
                    },
                    {
                        id:7,
                        name: 'Xiaojin',
                        content:['Shuangqiao Valley','Balang Mountain','Maobiliang Viewing Platform']
                    },
                ],
                levelListInfo:{//有哪些服务
                    levelTabList:levelTabList,
                    allServerListList:[
                        {
                            id:1,
                            serverList:serverList1,
                            // 轮播图
                             swiperList:[
                                {id:1,img:AdvancedImg1},
                                {id:2,img:AdvancedImg2},
                                {id:3,img:AdvancedImg3},
                                {id:4,img:AdvancedImg4}
                            ]
                        },
                        {
                            id:2,
                            serverList:serverList2,
                            swiperList:[
                                {id:1,img:DeluxeImg1},
                                {id:2,img:DeluxeImg2},
                                {id:3,img:DeluxeImg3},
                                {id:4,img:DeluxeImg4}
                            ]
                        },
                        {
                            id:3,
                            serverList:serverList3,
                            swiperList:[
                                {id:1,img:LuxuryImg1},
                                {id:2,img:LuxuryImg2},
                                {id:3,img:LuxuryImg3},
                                {id:4,img:LuxuryImg4}
                            ]
                        },
                    ],
                }
            },
        ]
    },
    {
        id:3,
        timeTabList:[
            {
                id:1,
                title:'Three-day itinerary',
            },
            {
                id:2,
                title:'Five-day itinerary',
            },
            {
                id:3,
                title:'Seven-day itinerary',
            },
            
        ],
        list:[
            {
                id:1,
                title:'Three-day itinerary',
                positionList:[//有哪些地方
                    {
                            id:1,
                            name: 'Chenghua',
                            content:['Giant Panda Breeding Research Base','East Gate Memory']
                    },
                    {
                        id:2,
                        name: 'Qingyang',
                        content:['Kuan & Zhai Alley','Wenshu Monastery ']
                    },
                    {
                        id:3,
                        name: 'Jinjiang',
                        content:['Chunxi Road Business District']
                    },
                    {
                        id:4,
                        name: 'Wuhou ',
                        content:['Wuhou Temple']
                    },
                    {
                        id:5,
                        name: 'Dujiangyan',
                        content:['Dujiangyan Scenic Area ']
                    },
                ],
                levelListInfo:{//有哪些服务
                    levelTabList:levelTabList,
                    allServerListList:[
                        {
                            id:1,
                            serverList:serverList1,
                            // 轮播图
                             swiperList:[
                                {id:1,img:AdvancedImg1},
                                {id:2,img:AdvancedImg2},
                                {id:3,img:AdvancedImg3},
                                {id:4,img:AdvancedImg4}
                             ]
                        },
                        {
                            id:2,
                            serverList:serverList2,
                            swiperList:[
                                {id:1,img:DeluxeImg1},
                                {id:2,img:DeluxeImg2},
                                {id:3,img:DeluxeImg3},
                                {id:4,img:DeluxeImg4}
                            ]
                        },
                        {
                            id:3,
                            serverList:serverList3,
                            swiperList:[
                                {id:1,img:LuxuryImg1},
                                {id:2,img:LuxuryImg2},
                                {id:3,img:LuxuryImg3},
                                {id:4,img:LuxuryImg4}
                            ]
                        },
                    ],
                }
        
            },
            {
                id:2,
                title:'Five-day itinerary',
                positionList:[//有哪些地方
                    {
                            id:1,
                            name: 'Chenghua',
                            content:['Giant Panda Breeding Research Base','East Gate Memory']
                    },
                    {
                        id:2,
                        name: 'Qingyang',
                        content:['Kuan & Zhai Alley','Wenshu Monastery','Sichuan Museum']
                    },
                    {
                        id:3,
                        name: 'Jinjiang',
                        content:['Chunxi Road Business District']
                    },
                    {
                        id:4,
                        name: 'Wuhou',
                        content:['Wuhou Temple']
                    },
                    {
                        id:5,
                        name: 'Dujiangyan',
                        content:['Dujiangyan Scenic Area','Qingcheng Front Mountain Scenic Area']
                    },
                    {
                        id:6,
                        name: 'Leshan',
                        content:['Sanxingdui Museum New Hall']
                    },  
                ],
                levelListInfo:{//有哪些服务
                    levelTabList:levelTabList,
                    allServerListList:[
                        {
                            id:1,
                            serverList:serverList1,
                            // 轮播图
                             swiperList:[
                                {id:1,img:AdvancedImg1},
                                {id:2,img:AdvancedImg2},
                                {id:3,img:AdvancedImg3},
                                {id:4,img:AdvancedImg4}
                             ]
                        },
                        {
                            id:2,
                            serverList:serverList2,
                            swiperList:[
                                {id:1,img:DeluxeImg1},
                                {id:2,img:DeluxeImg2},
                                {id:3,img:DeluxeImg3},
                                {id:4,img:DeluxeImg4}
                            ]
                        },
                        {
                            id:3,
                            serverList:serverList3,
                            swiperList:[
                                {id:1,img:LuxuryImg1},
                                {id:2,img:LuxuryImg2},
                                {id:3,img:LuxuryImg3},
                                {id:4,img:LuxuryImg4}
                            ]
                        },
                    ],
                }
        
            },
            {
                id:3,
                title:'Seven-day itinerary',
                positionList:[//有哪些地方
                    {
                            id:1,
                            name: 'Chenghua',
                            content:['Giant Panda Breeding Research Base','East Gate Memory']
                    },
                    {
                        id:2,
                        name: 'Qingyang',
                        content:['Kuan & Zhai Alley','Wenshu Monastery','People\'s Park','Sichuan Museum']
                    },
                    {
                        id:3,
                        name: 'Jinjiang',
                        content:['Chunxi Road Business District','Jiuyanqiao Bar Zone']
                    },
                    {
                        id:4,
                        name: 'Wuhou',  
                        content:['Wuhou Temple']
                    },
                    {
                        id:5,
                        name: 'Dujiangyan',
                        content:['Dujiangyan Scenic Area','Qingcheng Front Mountain Scenic Area']
                    },
                    {
                        id:6,
                        name: 'Guanghan',
                        content:['Sanxingdui Museum New Hall']
                    },
                    {
                        id:7,
                        name: 'leshan',
                        content:['Mount Emei','Leshan Giant Buddha']
                    },
                ],
                levelListInfo:{//有哪些服务
                    levelTabList:levelTabList,
                    allServerListList:[
                        {
                            id:1,
                            serverList:serverList1,
                            // 轮播图
                             swiperList:[
                                {id:1,img:AdvancedImg1},
                                {id:2,img:AdvancedImg2},
                                {id:3,img:AdvancedImg3},
                                {id:4,img:AdvancedImg4}
                            ]
                        },
                        {
                            id:2,
                            serverList:serverList2,
                            swiperList:[
                                {id:1,img:DeluxeImg1},
                                {id:2,img:DeluxeImg2},
                                {id:3,img:DeluxeImg3},
                                {id:4,img:DeluxeImg4}
                            ]
                        },
                        {
                            id:3,
                            serverList:serverList3,
                            swiperList:[
                                {id:1,img:LuxuryImg1},
                                {id:2,img:LuxuryImg2},
                                {id:3,img:LuxuryImg3},
                                {id:4,img:LuxuryImg4}
                            ]
                        },
                    ],
                }
            },
        ]
    },
    {
        id:4,
        timeTabList:[
            {
                id:1,
                title:'Three-day itinerary',
            },
            {
                id:2,
                title:'Five-day itinerary',
            },
        ],
        list:[
            {
                id:1,
                title:'Three-day itinerary',
                positionList:[//有哪些地方
                    {
                        id:1,
                        name: 'Yuzhong',
                        content:['Jiefangbei','Bayi Food Street','Liziba','Eling No.2 Factory Cultural and Creative Park','Hongyadong','Qiansimen Bridge',' Yangtze River Cableway']
                    },
                    {
                        id:2,
                        name: 'Shapingba',
                        content:['Ciqikou Ancient Town']
                    },
                    {
                        id:3,
                        name: 'Nan\'an',
                        content:['Longmenhao Old Street','Nanshan One Tree Observation Deck']
                    },
                    {
                        id:4,
                        name: 'Wulong',
                        content:['Wulong Tiankeng Three Bridges ']
                    },
                ],
                levelListInfo:{//有哪些服务
                    levelTabList:levelTabList,
                    allServerListList:[
                        {
                            id:1,
                            serverList:serverList1,
                            // 轮播图
                             swiperList:[
                                {id:1,img:AdvancedImg1},
                                {id:2,img:AdvancedImg2},
                                {id:3,img:AdvancedImg3},
                                {id:4,img:AdvancedImg4}
                             ]
                        },
                        {
                            id:2,
                            serverList:serverList2,
                            swiperList:[
                                {id:1,img:DeluxeImg1},
                                {id:2,img:DeluxeImg2},
                                {id:3,img:DeluxeImg3},
                                {id:4,img:DeluxeImg4}
                            ]
                        },
                        {
                            id:3,
                            serverList:serverList3,
                            swiperList:[
                                {id:1,img:LuxuryImg1},
                                {id:2,img:LuxuryImg2},
                                {id:3,img:LuxuryImg3},
                                {id:4,img:LuxuryImg4}
                            ]
                        },
                    ],
                }
        
            },
            {
                id:2,
                title:'Five-day itinerary',
                positionList:[//有哪些地方
                    {
                        id:1,
                        name: 'Yuzhong',
                        content:['Jiefangbei','Bayi Food Street','Liziba','Eling No.2 Factory Cultural and Creative Park','Hongyadong','Qiansimen Bridge',' Yangtze River Cableway','Huguang Guild Hall','Three Gorges Museum','Chaotianmen Raffles Exploration Gallery']
                    },
                    {
                        id:2,
                        name: 'Shapingba',
                        content:['Ciqikou Ancient Town']
                    },
                    {
                        id:3,
                        name: 'Nan\'an',
                        content:['Longmenhao Old Street','Nanshan One Tree Observation Deck']
                    },
                    {
                        id:4,
                        name: 'Wulong',
                        content:['Xiannvshan National Forest Park','Longshui Gorge Crevice']
                    },
                ],
                levelListInfo:{//有哪些服务
                    levelTabList:levelTabList,
                    allServerListList:[
                        {
                            id:1,
                            serverList:serverList1,
                            // 轮播图
                             swiperList:[
                                {id:1,img:AdvancedImg1},
                                {id:2,img:AdvancedImg2},
                                {id:3,img:AdvancedImg3},
                                {id:4,img:AdvancedImg4}
                             ]
                        },
                        {
                            id:2,
                            serverList:serverList2,
                            swiperList:[
                                {id:1,img:DeluxeImg1},
                                {id:2,img:DeluxeImg2},
                                {id:3,img:DeluxeImg3},
                                {id:4,img:DeluxeImg4}
                            ]
                        },
                        {
                            id:3,
                            serverList:serverList3,
                            swiperList:[
                                {id:1,img:LuxuryImg1},
                                {id:2,img:LuxuryImg2},
                                {id:3,img:LuxuryImg3},
                                {id:4,img:LuxuryImg4}
                            ]
                        },
                    ],
                }
        
            }
        ]
    },
    {
        id:5,
        timeTabList:[
            {
                id:1,
                title:'Three-dayA itinerary',
            },
            {
                id:2,
                title:'Three-dayB itinerary',
            },
            {
                id:3,
                title:'Three-dayC itinerary',
            },
            {
                id:4,
                title:'Five-dayA itinerary',
            },
            {
                id:5,
                title:'Five-dayB itinerary',
            },
            {
                id:6,
                title:'Five-dayC itinerary',
            },
        ],
        list:[
            {
                id:1,
                title:'Three-dayA itinerary',
                positionList:[//有哪些地方
                    {
                        id:1,
                        name: 'Liwan',
                        content:['Yongqing Fang','Panxi Restaurant','Chen Clan Ancestral Hall','Shamian Island']
                    },
                    {
                        id:2,
                        name: 'Yuexiu',
                        content:['Pearl River Night Cruise Crystal','Sacred Heart Cathedral','Beijing Road Pedestrian Street']
                    },
                    {
                        id:3,
                        name: 'Tianhe',
                        content:['Guangzhou K11 Art Mall','Guangdong Museum']
                    },
                    {
                        id:4,
                        name: 'Haizhu',
                        content:['Canton Tower Ferris Wheel']
                    },
                    {
                        id:5,
                        name: 'Panyu',
                        content:['Lingnan Impression Park']
                    },
                ],
                levelListInfo:{//有哪些服务
                    levelTabList:levelTabList,
                    allServerListList:[
                        {
                            id:1,
                            serverList:serverList1,
                            // 轮播图
                             swiperList:[
                                {id:1,img:AdvancedImg1},
                                {id:2,img:AdvancedImg2},
                                {id:3,img:AdvancedImg3},
                                {id:4,img:AdvancedImg4}
                             ]
                        },
                        {
                            id:2,
                            serverList:serverList2,
                            swiperList:[
                                {id:1,img:DeluxeImg1},
                                {id:2,img:DeluxeImg2},
                                {id:3,img:DeluxeImg3},
                                {id:4,img:DeluxeImg4}
                            ]
                        },
                        {
                            id:3,
                            serverList:serverList3,
                            swiperList:[
                                {id:1,img:LuxuryImg1},
                                {id:2,img:LuxuryImg2},
                                {id:3,img:LuxuryImg3},
                                {id:4,img:LuxuryImg4}
                            ]
                        },
                    ],
                }
        
            },
            {
                id:2,
                title:'Three-dayB itinerary',
                positionList:[//有哪些地方
                    {
                        id:1,
                        name: 'Liwan',
                        content:['Yongqing Fang','Panxi Restaurant','Chen Clan Ancestral Hall']
                    },
                    {
                        id:2,
                        name: 'Yuexiu',
                        content:['Pearl River Night Cruise Crystal']
                    },
                    {
                        id:3,
                        name: 'Shunde',
                        content:['Qinghui Garden','Snoopy Paradise','Fengjian Water Town']
                    },
                    {
                        id:4,
                        name: 'Chancheng',
                        content:['The Ancient Nanfeng Kiln','Foshan Ancestral Temple','Lingnan Tiandi']
                    },
                ],
                levelListInfo:{//有哪些服务
                    levelTabList:levelTabList,
                    allServerListList:[
                        {
                            id:1,
                            serverList:serverList1,
                            // 轮播图
                             swiperList:[
                                {id:1,img:AdvancedImg1},
                                {id:2,img:AdvancedImg2},
                                {id:3,img:AdvancedImg3},
                                {id:4,img:AdvancedImg4}
                             ]
                        },
                        {
                            id:2,
                            serverList:serverList2,
                            swiperList:[
                                {id:1,img:DeluxeImg1},
                                {id:2,img:DeluxeImg2},
                                {id:3,img:DeluxeImg3},
                                {id:4,img:DeluxeImg4}
                            ]
                        },
                        {
                            id:3,
                            serverList:serverList3,
                            swiperList:[
                                {id:1,img:LuxuryImg1},
                                {id:2,img:LuxuryImg2},
                                {id:3,img:LuxuryImg3},
                                {id:4,img:LuxuryImg4}
                            ]
                        },
                    ],
                }
        
            },
            {
                id:3,
                title:'Three-dayC itinerary',
                positionList:[//有哪些地方
                    {
                        id:1,
                        name: 'Panyu',
                        content:['Chimelong Safari Park']
                    },
                    {
                        id:2,
                        name: 'Xiangzhou',
                        content:['Zhuhai Sun Moon Bay','Hengqin Bay Fireworks Show','Diamond Beach','Forest Plank Road']
                    },
                    {
                        id:3,
                        name: 'Xiangzhou',
                        content:['Zhuhai Sun Moon Bay','Hengqin Bay Fireworks Show','Diamond Beach','Forest Plank Road']
                    },
                    {
                        id:4,
                        name: 'Pengjiang',
                        content:['Seafood Wharf']
                    },
                    {
                        id:5,
                        name: 'Bao\'an',
                        content:['Bay Area Glory Ferris Wheel']
                    },
                    {
                        id:6,
                        name: 'Bao\'an',
                        content:['DJI Flagship Store','Sea World']
                    },
                ],
                levelListInfo:{//有哪些服务
                    levelTabList:levelTabList,
                    allServerListList:[
                        {
                            id:1,
                            serverList:serverList1,
                            // 轮播图
                             swiperList:[
                                {id:1,img:AdvancedImg1},
                                {id:2,img:AdvancedImg2},
                                {id:3,img:AdvancedImg3},
                                {id:4,img:AdvancedImg4}
                             ]
                        },
                        {
                            id:2,
                            serverList:serverList2,
                            swiperList:[
                                {id:1,img:DeluxeImg1},
                                {id:2,img:DeluxeImg2},
                                {id:3,img:DeluxeImg3},
                                {id:4,img:DeluxeImg4}
                            ]
                        },
                        {
                            id:3,
                            serverList:serverList3,
                            swiperList:[
                                {id:1,img:LuxuryImg1},
                                {id:2,img:LuxuryImg2},
                                {id:3,img:LuxuryImg3},
                                {id:4,img:LuxuryImg4}
                            ]
                        },
                    ],
                }
        
            },
            {
                id:4,
                title:'Five-dayA itinerary',
                positionList:[//有哪些地方
                    {
                        id:1,
                        name: 'Liwan',
                        content:['Yongqing Fang','Panxi Restaurant','Chen Clan Ancestral Hall','Shamian Island']
                    },
                    {
                        id:2,
                        name: 'Yuexiu',
                        content:['Pearl River Night Cruise Crystal','Sacred Heart Cathedral','Beijing Road Pedestrian Street']
                    },
                    {
                        id:3,
                        name: 'Tianhe',
                        content:['Guangzhou K11 Art Mall','Guangdong Museum']
                    },
                    {
                        id:4,
                        name: 'Haizhu',
                        content:['Canton Tower Ferris Wheel']
                    },
                    {
                        id:5,
                        name: 'Panyu',
                        content:['Lingnan Impression Park']
                    },
                    {
                        id:5,
                        name: 'Chancheng',
                        content:['The Ancient Nanfeng Kiln','Foshan Ancestral Temple ']
                    },
                    {
                        id:6,
                        name: 'Shunde',
                        content:['Qinghui Garden','Fengjian Water Town']
                    },
                ],
                levelListInfo:{//有哪些服务
                    levelTabList:levelTabList,
                    allServerListList:[
                        {
                            id:1,
                            serverList:serverList1,
                            // 轮播图
                             swiperList:[
                                {id:1,img:AdvancedImg1},
                                {id:2,img:AdvancedImg2},
                                {id:3,img:AdvancedImg3},
                                {id:4,img:AdvancedImg4}
                             ]
                        },
                        {
                            id:2,
                            serverList:serverList2,
                            swiperList:[
                                {id:1,img:DeluxeImg1},
                                {id:2,img:DeluxeImg2},
                                {id:3,img:DeluxeImg3},
                                {id:4,img:DeluxeImg4}
                            ]
                        },
                        {
                            id:3,
                            serverList:serverList3,
                            swiperList:[
                                {id:1,img:LuxuryImg1},
                                {id:2,img:LuxuryImg2},
                                {id:3,img:LuxuryImg3},
                                {id:4,img:LuxuryImg4}
                            ]
                        },
                    ],
                }
        
            },
            {
                id:5,
                title:'Five-dayB itinerary',
                positionList:[//有哪些地方
                    {
                        id:1,
                        name: 'Liwan',
                        content:['Yongqing Fang','Panxi Restaurant','Liziba','Chen Clan Ancestral Hall']
                    },
                    {
                        id:2,
                        name: 'Yuexiu',
                        content:['Pearl River Night Cruise Crystal']
                    },
                    {
                        id:3,
                        name: 'Shunde',
                        content:['Qinghui Garden','Snoopy Paradise','Fengjian Water Town']
                    },
                    {
                        id:4,
                        name: 'Chancheng',
                        content:['The Ancient Nanfeng Kiln','Foshan Ancestral Temple','Lingnan Tiandi']
                    },
                    {
                        id:5,
                        name: 'Kaiping',
                        content:['Kaiping Zilicun Diaolou Group','Chikan Ancient Town']
                    },
                    {
                        id:6,
                        name: 'Enping',
                        content:['Enping Hot Spring Resort']
                    },
                    {
                        id:7,
                        name: 'Xinhui',
                        content:['Xinhui Tangerine Peel Village']
                    },
                    
                ],
                levelListInfo:{//有哪些服务
                    levelTabList:levelTabList,
                    allServerListList:[
                        {
                            id:1,
                            serverList:serverList1,
                            // 轮播图
                             swiperList:[
                                {id:1,img:AdvancedImg1},
                                {id:2,img:AdvancedImg2},
                                {id:3,img:AdvancedImg3},
                                {id:4,img:AdvancedImg4}
                             ]
                        },
                        {
                            id:2,
                            serverList:serverList2,
                            swiperList:[
                                {id:1,img:DeluxeImg1},
                                {id:2,img:DeluxeImg2},
                                {id:3,img:DeluxeImg3},
                                {id:4,img:DeluxeImg4}
                            ]
                        },
                        {
                            id:3,
                            serverList:serverList3,
                            swiperList:[
                                {id:1,img:LuxuryImg1},
                                {id:2,img:LuxuryImg2},
                                {id:3,img:LuxuryImg3},
                                {id:4,img:LuxuryImg4}
                            ]
                        },
                    ],
                }
        
            },
            {
                id:6,
                title:'Five-dayC itinerary',
                positionList:[//有哪些地方
                    {
                        id:1,
                        name: 'Panyu',
                        content:['Chimelong Safari Park']
                    },
                    {
                        id:2,
                        name: 'Xiangzhou',
                        content:['Zhuhai Sun Moon Bay','Hengqin Bay Fireworks Show','Diamond Beach','Forest Plank Road']
                    },
                    {
                        id:3,
                        name: 'Pengjiang',
                        content:['Seafood Wharf']
                    },
                    {
                        id:4,
                        name: 'Bao\'an',
                        content:['Bay Area Glory Ferris Wheel']
                    },
                    {
                        id:5,
                        name: 'Nanshan',
                        content:['DJI Flagship Store','Sea World']
                    },
                    {
                        id:6,
                        name: 'Kaiping City',
                        content:['Kaiping Zilicun Diaolou Group','Chikan Ancient Town']
                    },
                    {
                        id:7,
                        name: 'Enping',
                        content:['Enping Hot Spring Resort']
                    },
                    {
                        id:8,
                        name: 'Xinhui',
                        content:['Xinhui Tangerine Peel Village']
                    },
                    
                ],
                levelListInfo:{//有哪些服务
                    levelTabList:levelTabList,
                    allServerListList:[
                        {
                            id:1,
                            serverList:serverList1,
                            // 轮播图
                             swiperList:[
                                {id:1,img:AdvancedImg1},
                                {id:2,img:AdvancedImg2},
                                {id:3,img:AdvancedImg3},
                                {id:4,img:AdvancedImg4}
                             ]
                        },
                        {
                            id:2,
                            serverList:serverList2,
                            swiperList:[
                                {id:1,img:DeluxeImg1},
                                {id:2,img:DeluxeImg2},
                                {id:3,img:DeluxeImg3},
                                {id:4,img:DeluxeImg4}
                            ]
                        },
                        {
                            id:3,
                            serverList:serverList3,
                            swiperList:[
                                {id:1,img:LuxuryImg1},
                                {id:2,img:LuxuryImg2},
                                {id:3,img:LuxuryImg3},
                                {id:4,img:LuxuryImg4}
                            ]
                        },
                    ],
                }
        
            }
        ]
    }
]

export default{
    configurationLevelInfo,
}